export default __webpack_public_path__ + "img/preview.870b7a63.svg";